import { useState } from "react";
import SectionHeading from "./SectionHeading";
import { faqs } from "@/mocks/anime";

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const toggle = (index: number) => {
    setOpenIndex((current) => (current === index ? null : index));
  };

  return (
    <section id="faq" className="w-full bg-background-50 px-4 py-14 md:px-8 md:py-20">
      <div className="grid grid-cols-1 gap-10 lg:grid-cols-[0.85fr_1.15fr] lg:gap-14">
        <div className="lg:sticky lg:top-24 lg:self-start">
          <SectionHeading
            eyebrow="使用前先看这里"
            title="常见问题"
            desc="关于在线观看、资源下载与更新排期的常见疑问，点标题即可展开查看答案。还有没覆盖到的情况，可以再切换类型或关键词试试。"
          />
          <div className="mt-6 rounded-lg border border-secondary-200 bg-secondary-50 p-5">
            <span className="flex h-11 w-11 items-center justify-center rounded-md bg-secondary-500 text-background-50">
              <i className="ri-lightbulb-flash-line text-xl" />
            </span>
            <p className="mt-3 text-sm leading-relaxed text-secondary-900">
              小提示：把想追的作品按「连载中」和「已完结」分开记录，能避免同时开坑太多、最后哪部都没看完。
            </p>
          </div>
        </div>

        <div className="flex flex-col gap-3">
          {faqs.map((faq, index) => {
            const isOpen = openIndex === index;
            return (
              <div
                key={faq.q}
                className={`overflow-hidden rounded-lg border bg-background-100 transition-colors ${
                  isOpen ? "border-primary-300" : "border-background-200"
                }`}
              >
                <h3>
                  <button
                    type="button"
                    aria-expanded={isOpen}
                    onClick={() => toggle(index)}
                    className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left cursor-pointer"
                  >
                    <span className="flex items-center gap-3">
                      <span className="font-heading text-lg text-accent-700">
                        {String(index + 1).padStart(2, "0")}
                      </span>
                      <span className="font-heading text-lg text-foreground-950 md:text-xl">
                        {faq.q}
                      </span>
                    </span>
                    <i
                      className={`shrink-0 text-xl text-foreground-500 transition-transform ${
                        isOpen ? "ri-subtract-line" : "ri-add-line"
                      }`}
                    />
                  </button>
                </h3>
                {isOpen && (
                  <div className="border-t border-background-200 px-5 pb-5 pt-4">
                    <p className="text-sm leading-relaxed text-foreground-600">{faq.a}</p>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}